import { SidebarMediaProps } from '@/components/_blog-updates/SidebarMedia';
import { CraftSidebarMediaData } from './CraftSidebarMedia.types';

export const mapBlockToSidebarMediaProps = (
  block: CraftSidebarMediaData,
): SidebarMediaProps => {
  const isImage = block.sidebarMediaType === 'image';
  const isVideo = block.sidebarMediaType === 'video';
  const asset = block.sidebarMediaAsset?.[0];

  return {
    isImage,
    isVideo,
    imageSrc: isImage ? asset?.url : undefined,
    videoSrc: isVideo ? asset?.url : undefined,
    caption: block.sidebarMediaCaption,
    description: block.sidebarMediaDescription,
    videoDuration: block.sidebarMediaDuration,
  };
};
